import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LanguageType} from '../shared/types';

const HEBREW_TEXT_FEMALE = `עוד רגע נצא למסע בין כ 50 דקות בשבילי הפארק. אם את צריכה לעצור או לחזור לאחור את יכולה להשתמש בציר הזמן שמופיע למעלה בכל אחד מהעמודים.
בין פרק לפרק תתבקשי לחפש בפארק לוח מתכת זהוב. תסרקי אותו. כדאי לך.
`;
const HEBREW_TEXT_MALE = `עוד רגע נצא למסע בין כ 50 דקות בשבילי הפארק. אם אתה צריך לעצור או לחזור לאחור אתה יכול להשתמש בציר הזמן שמופיע למעלה בכל אחד מהעמודים.
בין פרק לפרק תתבקש לחפש בפארק לוח מתכת זהוב. תסרוק אותו. כדאי לך.
`;
const ENGLISH_TEXT = `We are about to begin a 50 minutes tour in the park. If you need to stop or go back to a previous chapter, you can use the timeline bar that appears above.
Between each chapter, you will be asked to scan a golden plaque that will reveal a surprise.`;

@Component({
  selector: 'app-navigation-page',
  templateUrl: './navigation-description-page.component.html',
  styleUrls: ['./navigation-description-page.component.scss']
})
export class NavigationDescriptionPageComponent implements OnInit {

  @Input() language: LanguageType = 'hebrew';
  @Input() isFemale = true;

  @Output() continueEvent = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  get buttonText(): string {
    return this.language === 'english' ? 'Continue' : (this.isFemale ? 'המשיכי' : 'המשך');
  }

  get description(): string {
    return this.language === 'english' ? ENGLISH_TEXT : (this.isFemale ? HEBREW_TEXT_FEMALE : HEBREW_TEXT_MALE);
  }

}
